import script from "./FormFrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"

import "./FormFrequenciaEncontro.vue?vue&type=style&index=0&id=63ea2595&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ea2595"]])

export default __exports__